import React from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { get } from "lodash";
import {
  Icon,
  AlertInline,
  useMediaQuery,
  breakpoints
} from "@tvg/design-system";
import { isMobileServerSide } from "@tvg/sh-utils/mobileUtils";
import { RaceStatusEnum } from "@tvg/ts-types/Race";

import { useIsLiveTv } from "../../hooks";
import { getProgramPageMessages } from "../../store/selectors";

import { AlertInlineContainer } from "./styled-components";
import { Props } from "./types";

const NextBettableRaceAlert = ({
  currentRaceStatus,
  nextBettableRaceUrl,
  isLoading
}: Props) => {
  const navigate = useNavigate();
  const isLiveTv = useIsLiveTv();
  const isMobile =
    useMediaQuery(breakpoints.tablet.max.sm) || isMobileServerSide();

  const programPageMessages = useSelector(getProgramPageMessages);

  if (
    isLoading ||
    !isLiveTv ||
    !nextBettableRaceUrl ||
    currentRaceStatus !== RaceStatusEnum.RACE_OFFICIAL
  ) {
    return null;
  }

  return (
    <AlertInlineContainer data-qa-label="next-bettable-race-container">
      <AlertInline
        message={get(
          programPageMessages,
          "resulted.nextBettableRaceMessageTitle",
          "Result Final"
        )}
        qaLabel="next-bettable-race-message"
        variant="informational"
        type="fixed"
        padding={isMobile ? "space-2" : "space-4"}
        paddingX="space-4"
        actionLink={
          <AlertInline.Link
            qaLabel="next-bettable-race-link"
            onPress={() => navigate(nextBettableRaceUrl)}
          >
            <>
              {get(
                programPageMessages,
                "resulted.nextBettableRaceMessageLink",
                "Go to the next betting race"
              )}
              <Icon
                qaLabel="next-bettable-race-icon"
                name="arrowRight"
                size="s"
                ml="space-4"
                lineColor="blue_accent.700"
              />
            </>
          </AlertInline.Link>
        }
      />
    </AlertInlineContainer>
  );
};

export default NextBettableRaceAlert;
